import { useEffect } from 'react';
import { db } from '../firebase';
import { onSnapshot, doc } from 'firebase/firestore';
import useAuthStore from '../stores/authStore';
import useUsageStore from '../stores/usageStore';
import useSubscriptionStore from '../stores/subscriptionStore';

const useUsageListener = () => {
    const { user } = useAuthStore();
    const { setUsage, setIsLoading } = useUsageStore();
    const { subscription, isLoading: isSubscriptionLoading, isDemo } = useSubscriptionStore();

    useEffect(() => {
        if (!user || !user.emailVerified || isSubscriptionLoading) {
            return;
        }

        if (isDemo) {
            setIsLoading(false);
            return;
        }

        const startDate = subscription.currentPeriodStart.toDate();
        const timestampInSeconds = Math.floor(startDate.getTime() / 1000);
        const usageRef = doc(db, 'users', user.uid, 'usages', timestampInSeconds.toString());

        const unsubscribe = onSnapshot(usageRef, (snapshot) => {
            if (snapshot.exists()) {
                setUsage({
                    id: snapshot.id,
                    ...snapshot.data()
                });
            } else {
                setUsage(null);
            }
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [
        user,
        subscription?.currentPeriodStart,
        setIsLoading,
        setUsage,
        isSubscriptionLoading,
        isDemo
    ]);
};

export default useUsageListener;
